import React, { Component } from 'react';

// import { SecretClient } from "@azure/keyvault-secrets";

import { Button } from "grommet";
import { Helmet } from "react-helmet";

export default class ExportPage extends Component {

  constructor() {
    super();
    this.state = {
      module: 'Events',
      secdim: 'eventAction',
    };
    this.setLogin = this.setLogin.bind(this);
    this.account = "fcd20cf469a8111e9be2366";
    this.shareName = "kubernetes-dynamic-pvc-9f5aa6c6-efb0-11e9-b720-a6c19b4f259b";
    this.directoryName = ["vb4fRe6zFTXuqQvbsvmW8vHE", "content"];
    this.appdetails = {
      clientId: "720f8c6b-406e-473c-8f48-103c54ccbbc1",
      authorityHost: "https://login.microsoftonline.com",
      tenantId: "c5f9cef3-6300-4cc2-90f6-be1b3f6e31d8"
    };
  }

  async setLogin() {

    const { InteractiveBrowserCredential } = await import(/* webpackChunkName: "@azure/identity" */ '@azure/identity');
    const { ShareServiceClient } = await import(/* webpackChunkName: "@azure/storage-file-share" */ '@azure/storage-file-share');
    // Enter your storage account name
    const defaultAzureCredential = new InteractiveBrowserCredential(this.appdetails);

    // https://fcd20cf469a8111e9be2366.file.core.windows.net/kubernetes-dynamic-pvc-9f5aa6c6-efb0-11e9-b720-a6c19b4f259b/vb4fRe6zFTXuqQvbsvmW8vHE/content?sp=rl&st=2020-02-17T03:17:43Z&se=2021-01-01T03:17:00Z&sv=2019-02-02&sig=mhWAa2QRioKK86WNG7%2FOddJTdCh56XMdGzBBZYChLU4%3D&sr=f&restype=directory&comp=list&_=1581910881794
    // https://fcd20cf469a8111e9be2366.file.core.windows.net/kubernetes-dynamic-pvc-9f5aa6c6-efb0-11e9-b720-a6c19b4f259b/vb4fRe6zFTXuqQvbsvmW8vHE/content/?sp=rl&st=2020-02-17T03:17:43Z&se=2021-01-01T03:17:00Z&sv=2019-02-02&sig=mhWAa2QRioKK86WNG7%2FOddJTdCh56XMdGzBBZYChLU4%3D&sr=f
    const secret = "?sp=rl&st=2020-02-15T03:31:00Z&se=2021-02-17T22:51:00Z&sv=2019-02-02&sig=RL5mM1ST9T%2FLOc3vVyYraxou9q7ZUWfcNKmbsfA2Nc4%3D&sr=f";

    const serviceClient = new ShareServiceClient(
      `https://${this.account}.file.core.windows.net/${secret}`,
      defaultAzureCredential
    );

    const directoryClient = this.directoryName.reduce((p, dir) => p.getDirectoryClient(dir), serviceClient.getShareClient(this.shareName));
    let dirIter = directoryClient.listFilesAndDirectories();
    let i = 1;
    const files = [];
    for await (const item of dirIter) {
      if (item.kind === "directory") {
        console.log(`${i} - directory\t: ${item.name}`);
      } else {
        console.log(`${i} - file\t: ${item.name}`);
        files.push(item.name);
      }
      i++;
    }

    this.setState({ files });
  }

  render() {

    return !this.state.token ? (<div>
      <p>You need to log in to see this report</p>
      <Button onClick={this.setLogin} label="Log in" primary />
    </div>) : (
      <div>
        <ul>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Exports - MD Dashboard</title>
        </Helmet>
        {this.state?.files.map(i => <li>{i}</li>)}
        </ul>
      </div>
    );
  }
}
